@if (_internalView) {
    <div class="list-selector-container" [ngClass]="{ hidden: !(_internalView.viewType === ViewType.Box || _internalView.viewType === ViewType.ArchivingBox) }">
        <div class="view-container">
            @if ((_internalView.viewType === ViewType.Box || _internalView.viewType === ViewType.ArchivingBox) && listSelectorIsOpen) {
                <app-folders-list-boxes-selector></app-folders-list-boxes-selector>
            }
        </div>
        <div class="list-selector-icon">
            @if (listSelectorIsOpen) {
                <mat-icon (click)="listSelectorClick(false)">arrow_circle_left</mat-icon>
            } @else {
                <mat-icon (click)="listSelectorClick(true)">arrow_circle_right</mat-icon>
            }
        </div>
    </div>
}
